import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "min-h-screen text-xl bg-slate-200 dark:bg-gray-900 text-gray-900 dark:text-slate-200",
  role: "main",
  tabindex: "-1"
}
const _hoisted_2 = { class: "container px-8 py-10 mx-auto grid gap-8" }

import "@/assets/css/main.css";
import { RouterView } from "vue-router";
import Header from "@/components/HeaderComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RouterView))
      ])
    ])
  ], 64))
}
}

})